import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints';

const mobileBreakpointNum = parseInt(BREAKPOINTS.lg, 10) - 1;
const mobileBreakpoint = `${mobileBreakpointNum}px`;

const breakpoints = {
    mobile: mobileBreakpoint,
    medium: BREAKPOINTS.xl
};

export default breakpoints;
